import React, { useEffect, useState } from 'react';
import {
    Box,
    Typography,
    IconButton,
    Card,
    CardMedia,
    CardContent,
    CardActions,
    Grid,
    Container,
    Button
} from '@mui/material';
import { Favorite, FavoriteBorder } from '@mui/icons-material';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import ImageIcon from '@mui/icons-material/Image';




function Gallery() {
    const [photos, setPhotos] = useState([]);
    const [likedPhotos, setLikedPhotos] = useState([]);

    useEffect(() => {
        fetchGallery();
        const storedLikes = JSON.parse(localStorage.getItem('likedPhotos')) || [];
        setLikedPhotos(storedLikes);
    }, []);

    const fetchGallery = async () => {
        const snapshot = await getDocs(collection(db, 'gallery'));
        const data = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
            likes: doc.data().likes || 0,
        }));
        setPhotos(data);
    };

    const handleLike = async (id) => {
        if (likedPhotos.includes(id)) return;

        const newLikes = [...likedPhotos, id];
        localStorage.setItem('likedPhotos', JSON.stringify(newLikes));
        setLikedPhotos(newLikes);

        const photoRef = doc(db, 'gallery', id);
        const photo = photos.find((p) => p.id === id);
        await updateDoc(photoRef, {
            likes: (photo.likes || 0) + 1,
        });

        // Update UI
        setPhotos((prev) =>
            prev.map((p) =>
                p.id === id ? { ...p, likes: (p.likes || 0) + 1 } : p
            )
        );
    };

    return (
        <>
            <Box>
                <Box>
                    <Box sx={{ padding: 4, minHeight: '100vh' }}>
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 'bold',
                            mb: 4,
                            mt: 2,
                            color: '#fff',
                            fontFamily: '"Roboto", sans-serif',
                            textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                            textAlign: 'left'
                        }}
                    >
                        <span style={{ marginRight: 10 }}><ImageIcon style={{ fontSize: 50, marginTop: -10 }} /></span>Galerie
                    </Typography>
                        <Grid container spacing={3}>
                            {photos.map((photo) => (
                                <Grid item key={photo.id} xs={12} sm={6} md={4} lg={3}>
                                    <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
                                        <CardMedia
                                            component="img"
                                            height="250"
                                            image={photo.imageUrl}
                                            alt={photo.caption}
                                            sx={{ objectFit: 'cover' }}
                                        />
                                        <CardContent>
                                            <Typography variant="body1">{photo.caption}</Typography>
                                        </CardContent>
                                        <CardActions>
                                            <IconButton
                                                onClick={() => handleLike(photo.id)}
                                                color="error"
                                            >
                                                {likedPhotos.includes(photo.id) ? (
                                                    <Favorite />
                                                ) : (
                                                    <FavoriteBorder />
                                                )}
                                            </IconButton>
                                            <Typography variant="body2">{photo.likes} likes</Typography>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </Box>
                <br/>
                <br/>
            </Box>

        </>

    );
}

export default Gallery;
